import TlDeptSelect from "./src/index.vue";

TlDeptSelect.install = function (Vue) {
  Vue.component(TlDeptSelect.name, TlDeptSelect);
};

export default TlDeptSelect;
